import React                       from 'react'
import { observer }                from 'mobx-react'
import styled                      from 'styled-components'
import store, { STEPS }            from 'stores/ResetPasswordStore'

import UsernameVerificationForm    from './UsernameVerificationForm'
import NewPasswordForm             from './NewPasswordForm'
import ConfirmationForm            from './ConfirmationForm'
import DeliveryForm                from './DeliveryForm'
import StepsIndicator              from './StepsIndicator'
import FailedRoute                 from './FailedRoute'
import SSButton                    from 'ui/shell/SSButton'

import { Wrapper, ContentWrapper } from '../Common/'

import { Switch, Route }           from 'react-router'


class ResetPassword extends React.Component {
  constructor(props) {
    super(props)
    store.setHistory(props.history)
  }

  render() {
    return (
      <ContentWrapper>
        <StepsIndicator {...this.props} />
        <Content>
          <TextHeader>
            Reset Your Password
          </TextHeader>
          <Switch>
            <Route
              exact
              path="/reset"
              component={UsernameVerificationForm}
            />
            <Route
              path="/reset/delivery_method/:userId"
              component={DeliveryForm}
            />
            <Route
              path="/reset/confirmation_code/:userId/:confirmationCode?/:deliveryMethod?"
              component={ConfirmationForm}
            />
            <Route
              path="/reset/new_password/:userId"
              component={NewPasswordForm}
            />
            <Route component={FailedRoute} />
          </Switch>
          <Footer>
            <SSButton
              outline
              color="#4C5056"
              iconClass="icon icon-home"
              onClick={() => {
                window.location.replace('/r')
              }}
              style={{borderRadius: '8px', border: '1px solid var(--Neutral-Gray-900, #4C5056)', backgroundColor: 'white'}}
            >
              Home
            </SSButton>
            <SSButton
              outline
              className="ml-2"
              color="#4C5056"
              iconClass="icon icon-ccw"
              onClick={() =>
                store.setCurrentStep(STEPS.USERNAME_VERIFICATION)
              }
              disabled={store.showUsernameVerification}
              style={{borderRadius: '8px', border: '1px solid var(--Neutral-Gray-900, #4C5056)'}}
            >
              Restart
            </SSButton>
          </Footer>
        </Content>
      </ContentWrapper>
    )
  }
}

const Content = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: start;
  margin-left: 8px
`

const TextHeader = styled.div`
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: #111827;
  margin-bottom: 25px;
`

const Footer = styled.div`
  display: flex;
  width: 100%;
`

const PWResetButton = styled.button`
  border-radius: 8px;
  border: 1px solid var(--Neutral-Gray-900, #4C5056);
`

export default observer(ResetPassword)
